module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--procedures_vote-caa08d6f4afe35151d182b0b65e12dce.jpg";